import { render, staticRenderFns } from "./modifyMove.vue?vue&type=template&id=7c5dc1d8&scoped=true"
import script from "./modifyMove.vue?vue&type=script&lang=js"
export * from "./modifyMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5dc1d8",
  null
  
)

export default component.exports